import type { ClientCard } from "@mnp/shared";

interface ContactPopoverProps {
  client: ClientCard;
  onClose?: () => void;
}

export function ContactPopover({ client, onClose }: ContactPopoverProps) {
  const phoneHref = client.phone ? `tel:${client.phone}` : undefined;
  const tgHref = client.tgUsername ? `https://t.me/${client.tgUsername.replace(/^@/, "")}` : undefined;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-3 shadow-lg" role="dialog" aria-label="Связаться">
      <div className="mb-2 flex items-center justify-between gap-3">
        <div className="text-sm font-semibold text-gray-900">Связаться</div>
        {onClose && (
          <button type="button" onClick={onClose} className="text-sm text-gray-500 hover:text-gray-900">
            Закрыть
          </button>
        )}
      </div>
      <div className="grid gap-2">
        <a className="btn-secondary text-center" href={tgHref} aria-disabled={!tgHref}>
          Telegram
        </a>
        <a className="btn-secondary text-center" href={phoneHref} aria-disabled={!phoneHref}>
          Позвонить
        </a>
        <button
          type="button"
          className="btn-secondary"
          onClick={() => void navigator.clipboard?.writeText(`Здравствуйте, ${client.name}. Ваши заказы готовы к выдаче.`)}
        >
          Шаблон сообщения
        </button>
      </div>
    </div>
  );
}
